<template>
  <span>
    <span v-if="isEdditing" v-on-clickaway="cancel">
      <form class="form-inline" @submit.prevent="save">
        <div class="input-group">
          <masked-input type="text" ref="locationInput" class="form-control" v-model="inputLocation" style="width: 130px;" mask="A.11.11.11.11" placeholder="_.__.__.__.__" />
          <span class="input-group-btn">
            <button type="submit" class="btn btn-success btn-noborder">
              <i class="fa fa-spinner fa-spin" v-if="loading"></i>
              <i class="fa fa-check" v-else></i>
            </button>
          </span>
        </div>
      </form>
    </span>

    <span @click="edit" v-else>
      <span class="editable text-primary" v-if="location">{{location}}</span>
      <span class="editable text-danger" v-else><i>n.n.b.</i></span>
    </span>

    <text-alert :alert.sync="alert"></text-alert>
  </span>
</template>

<script>
import http from '../utils/http'
import { mixin as clickaway } from 'vue-clickaway'
import MaskedInput from 'vue-masked-input'

export default {
  mixins: [clickaway],
  components: {
    MaskedInput
  },
  props: ['field', 'value', 'productId'],
  data () {
    return {
      isEdditing: false,
      location: this.value,
      inputLocation: '',
      loading: false,
      alert: false
    }
  },
  created () {
    this.$root.$on('product-location-updated', this.onUpdate)
  },
  destroy () {
    this.$root.$off('product-location-updated', this.onUpdate)
  },
  methods: {
    edit () {
      if (this.location) {
        this.inputLocation = this.location
      } else {
        const lastLocation = localStorage.getItem('last_assigned_location')
        if (lastLocation) {
          this.inputLocation = lastLocation.slice(0, -2)
        }
      }

      this.alert = false
      this.isEdditing = true

      const cursorPosition = this.inputLocation.length
      this.$nextTick(() => {
        const el = this.$refs.locationInput.$el
        el.focus()
        el.setSelectionRange(cursorPosition, cursorPosition)
      })
    },
    cancel () {
      this.isEdditing = false
      this.alert = false
      this.inputLocation = ''
    },
    save () {
      let value
      if (this.inputLocation === '') {
        value = null
      } else if (this.inputLocation.endsWith('.__')) {
        value = this.inputLocation.slice(0, -3) // remove '.__'
      } else {
        value = this.inputLocation
      }

      this.loading = true

      const data = {
        [this.field]: value
      }

      return http.patch(`/products/${this.productId}`, data)
        .then((response) => {
          this.location = value
          this.inputLocation = ''
          this.isEdditing = false
          this.loading = false

          this.alert = { variant: 'success', message: 'Opgeslagen' }

          this.$root.$emit('product-location-updated', {
            product_id: this.productId,
            location: value
          })

          if (this.location !== null) {
            localStorage.setItem('last_assigned_location', this.location)
          }
        })
        .catch((error) => {
          this.loading = false
          if (error.response.data.code === 'location_occupied') {
            this.alert = { variant: 'danger', message: 'Deze locatie is al bezet' }
          } else {
            this.alert = { variant: 'danger', message: 'Er is iets fout gegaan' }
          }
        })
    },
    onUpdate (e) {
      if (this.productId === e.product_id) {
        this.location = e.location
        this.inputLocation = e.location
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// LocationEditable.vue?492df921